import { useRenameCampaignMutation } from '@/entities/campaign/mutation/use-rename-campaign-mutation';

import { requestRenameCampaignDialog } from './request-rename-campaign-dialog';

export const useRenameCampaignRequest = () => {
  const renameCampaignMutation = useRenameCampaignMutation();

  const onRenameCampaign = async (campaignId: string, campaignName: string) => {
    if (renameCampaignMutation.isPending) return;

    await requestRenameCampaignDialog({
      initialName: campaignName,
      onSave: async (nextCampaignName) => {
        await renameCampaignMutation.mutateAsync({
          campaignId,
          campaignName: nextCampaignName,
        });
      },
    });
  };

  return onRenameCampaign;
};
